import { Action } from '@nextforce/api'
import { UseMutationResult } from '@tanstack/react-query'
import { cloneDeep } from 'lodash'
import { Setting, SettingValue, SingleSelectSetting } from 'settings/types'
import { SettingsSource } from './queries/shared/types'

export function getSettingsAction(setting: Setting, values: any) {
  const action = cloneDeep(setting.actions.update)
  const preference = {
    name: setting.id,
    values: values,
  }
  if (action.params) {
    if (action.params.preferences) {
      action.params.preferences = [preference]
    } else {
      action.params.profile = [preference]
    }
  }
  return action
}

export function getSettngsSource(
  type: SettingsSource['type'],
  storeId?: string
): SettingsSource {
  switch (type) {
    case 'user':
      return { type: 'user' }
    case 'store':
      return {
        type: 'store',
        storeId,
      }
    case 'store_preferences':
      return {
        type: 'store_preferences',
        storeId,
      }
    default:
      return { type: 'user' }
  }
}

export async function onBooleanSettingChanged(
  setting: Setting,
  value: boolean,
  mutation: UseMutationResult<void, unknown, Action, void>
) {
  const action = getSettingsAction(setting, [value])
  await mutation.mutateAsync(action)
}

export async function onSingleSelectValue(
  setting: Setting,
  value: SettingValue,
  mutation: UseMutationResult<void, unknown, Action, void>
) {
  if (setting?.type === 'singleSelect') {
    const action = getSettingsAction(setting, [value.id])
    await mutation.mutateAsync(action)
  }
}

export async function onMultiSelectValue(
  setting: Setting,
  newSelectedIds: string[],
  mutation: UseMutationResult<void, unknown, Action, void>
) {
  if (setting?.type === 'multiSelect') {
    const action = getSettingsAction(setting, newSelectedIds)
    await mutation.mutateAsync(action)
  }
}

export function onPressSetting(
  setting: Setting,
  //TODO: hanldeNavigation type
  handleNavigation: any,
  settingsSource: SettingsSource
) {
  handleNavigation({
    routeName: 'setting_item',
    routeParams: {
      id: setting.id,
      ...settingsSource,
    },
  })
}
